/**
 * math.format(math.evaluate('0.1+0.2'))
 */

import { create, all } from 'mathjs'
const config = {
  epsilon: 1e-12,
  matrix: 'Matrix',
  number: 'BigNumber', // 可选值：number BigNumber
  precision: 64,
  predictable: false,
  randomSeed: null
}
const mathUtil = create(all, config)
export default mathUtil
